import { Breakpoint, Color, QuizAnswer, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

// TODO: wydzielić na osobny komponent
import { VideoSection } from '../../../../interactions';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 1;
  flex-shrink: 0;
  background-color: ${Color.Gray100};
  padding: 32px 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding: 32px;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding-bottom: 15px;
  border-bottom: 2px solid ${Color.Brand300};
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const StyledHeaderTypography = styled(Typography)`
  color: ${Color.Gray600};
`;

export const VideoWrapper = styled.div`
  display: flex;
  gap: 40px;
  flex-direction: column;
  align-items: end;
`;

export const StatementsWrapper = styled.div`
  border: 2px solid ${Color.Gray300};
`;

export const TopWrapper = styled.div`
  padding: 31px;
  background-color: ${Color.White};
  width: 100%;
`;

export const Statements = styled.div`
  display: flex;
  flex-direction: column;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const StatementWrapper = styled.div`
  padding: 54px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  gap: 40px;

  &:first-child {
    border-bottom: 2px solid ${Color.Gray300};
  }

  @media ${Breakpoint.SmallDesktop} {
    padding: 41px 32px;
    width: 50%;
    min-height: 523px;
    justify-content: space-between;

    &:first-child {
      border-bottom: none;
      border-right: 2px solid ${Color.Gray300};
    }
  }

  @media ${Breakpoint.Desktop} {
    padding: 41px 56px;
  }
`;

export const StyledVideoSection = styled(VideoSection)`
  width: 100%;
`;

export const StyledTypography = styled(Typography)`
  text-align: center;
`;

export const BottomWrapper = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  flex-direction: column;
  align-items: center;
`;

export const StyledQuizAnswer = styled(QuizAnswer)`
  width: 100%;
  min-height: 56px;
`;
